import React, { memo, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { getCustomerCities, getCustomerStates } from 'utlis/Apis/Customers_API'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import AppFormikInputInline from 'utlis/helpers/forms/AppFormikInputInline'
import AppFormikSelectInline from 'utlis/helpers/forms/AppFormikSelectInline'

function FormVendors__Details(props) {
    const { authState, formik, countries } = props
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])

    useEffect(() => {
        const { country, state } = formik.values || {}
        if (country) {
            getStates_(country)
        }
        if (state) {
            getCities_(state)
        }
    }, [formik.values.country])
    const getStates_ = (country_id) => {
        setStates([])
        setCities([])
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCustomerStates(headers, country_id).then(res => {
            const stateData = res.data
            if (stateData.success) {
                setStates(stateData.data)
            }

            if (stateData.error) {
                console.log('Error occured while loading states!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getStates `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }

    const getCities_ = (region_id) => {
        setCities([])
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCustomerCities(headers, region_id).then(res => {
            const cityData = res.data
            if (cityData.success) {
                setCities(cityData.data)
            }

            if (cityData.error) {
                console.log('Error occured while loading cities!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCities `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
            })
        })
    }

    return (
        <React.Fragment>
            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"First Name"}
                isRequired={true}
                placeholder={"First Name"}
                formikFieldName={"first_name"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Last Name"}
                isRequired={true}
                placeholder={"Last Name"}
                formikFieldName={"last_name"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Company Name"}
                isRequired={true}
                placeholder={"Company Name"}
                formikFieldName={"company_name"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={" st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-1"}
                labelName={"Tax Id/EIN"}
                isRequired={false}
                placeholder={"XX-XXXXXXX"}
                inputType={"text"}
                formikFieldName={"license_number"}
                onChange={(e) => {
                    let value = e.target.value
                    value = value.replace(/[^0-9]/ig, '')
                    if (value.length > 10) {
                        value = value.slice(0, 10)
                    }

                    if (value.length > 2) {
                        const v = value
                        const p1 = value.slice(0, 2)
                        const p2 = v.slice(2, v.length)
                        value = p1 + "-" + p2
                    }
                    formik?.setFieldValue("license_number", value)
                }}
            />


            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Email"}
                isRequired={true}
                placeholder={"Email"}
                formikFieldName={"email"}
                inputType="email"
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Address"}
                isRequired={false}
                placeholder={"Address"}
                formikFieldName={"address"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Address1"}
                isRequired={false}
                placeholder={"address1"}
                formikFieldName={"address1"}
            />

            <AppFormikSelectInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"Country"}
                isRequired={false}
                formikFieldName={"country"}
                onChange={(country) => {
                    getStates_(country)
                    formik.setFieldValue("state", "")
                    formik.setFieldValue("city", "")
                }}
                disabled={countries.length === 0}
            >
                <option disabled value="">Select Country</option>
                {(countries && countries.length) && countries.map(item => (
                    <option
                        key={item.country_id.toString()}
                        value={item.country_id.toString()}>{item.country}</option>
                ))
                }
            </AppFormikSelectInline>

            <AppFormikSelectInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"State"}
                isRequired={false}
                formikFieldName={"state"} onChange={(state) => {
                    getCities_(state)
                    formik.setFieldValue("city")
                }}
                disabled={states.length === 0}
            >
                <option disabled value="">Select State</option>
                {(states && states.length) && states.map(item => (
                    <option
                        key={item.region_id.toString()}
                        value={item.region_id.toString()}>{item.region}</option>
                ))
                }
            </AppFormikSelectInline>
            <AppFormikSelectInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex flex-wrap align-items-center mb-1"}
                labelName={"City"}
                isRequired={false}
                formikFieldName={"city"}
                disabled={cities.length === 0}
            >
                <option disabled value="">Select City</option>
                {(cities && cities.length) && cities.map(item => (
                    <option
                        key={item.city_id.toString()}
                        value={item.city_id.toString()}>{item.city}</option>
                ))
                }
            </AppFormikSelectInline>


            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-1"}
                labelName={"Zipcode"}
                isRequired={false}
                inputType={"number"}
                placeholder={"Zipcode"}
                formikFieldName={"zipcode"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-1"}
                labelName={"Phone"}
                isRequired={false}
                placeholder={"Phone"}
                formikFieldName={"phone"}
                inputType={"phone"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-1"}
                labelName={"Mobile"}
                isRequired={false}
                placeholder={"Mobile"}
                formikFieldName={"mobile"}
                inputType={"number"}
            />

            <AppFormikInputInline
                formik={formik}
                stFormClass={"st-form-with-label-left d-flex no-arrows flex-wrap align-items-center mb-1"}
                labelName={"fax"}
                isRequired={false}
                placeholder={"Fax"}
                formikFieldName={"fax"}
                inputType={"number"}
            />
        </React.Fragment>
    )
}

export default memo(FormVendors__Details)